import { Component } from '@angular/core';

@Component({
    selector: 'app-login-lawservices',
    templateUrl: './login-lawservices.component.html',
    styleUrl: './login-lawservices.component.css',
    standalone: false
})
export class LoginLawservicesComponent {

  constructor() {
  }
}
